<script setup lang="ts">
import { Formulator } from 'front-library'
import { ref, onMounted } from 'vue'
import { useUserStore } from '@/store/user'
import { getPrefixes, getSavedFormulas } from '@/app/core/services/prefixes'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = withDefaults(
  defineProps<{
    modelValue: string
    label?: string
    disabled?: boolean
    amount?: number
    notSavedFormulas?: boolean
  }>(),
  {
    modelValue: '',
    label: '',
    disabled: false,
    notSavedFormulas: false
  }
)

interface typesFormula {
  personalized: any[]
  standard: any[]
  entity: any[]
  saved: any[]
}

const emit = defineEmits(['update:modelValue'])

const formulas = ref<typesFormula>()
const store = useUserStore()
const labelF = props.label ? props.label : t('components.formula.label')

const emitUpdate = (val: any) => {
  if (typeof val === 'string') val = val.trim()
  emit('update:modelValue', val)
}

onMounted(async () => {
  if (store.prefixes_formulas === null || props.amount === 0) {
    const entity = new Promise(resolve => {
      resolve(getPrefixes('Entidad'))
    })
    const standard = new Promise(resolve => {
      resolve(getPrefixes('Estandar'))
    })
    const personalized = new Promise(resolve => {
      resolve(getPrefixes('Personalizada'))
    })
    const saved = new Promise(resolve => {
      resolve(getSavedFormulas())
    })
    void Promise.all([entity, standard, personalized, saved]).then(
      (results: any) => {
        formulas.value = {
          entity: results[0],
          standard: results[1],
          personalized: results[2],
          saved: props.notSavedFormulas ? [] : results[3]
        }
        store.prefixes_formulas = formulas.value
      }
    )
  } else {
    formulas.value = store.prefixes_formulas
  }
})
</script>
<template>
  <Formulator
    :model-value="modelValue"
    :formulas="formulas"
    :label="labelF"
    :disabled="disabled"
    @update:modelValue="emitUpdate" />
</template>
